/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EquipmentFirmwareFamily } from './equipment-firmware-family';
import { EquipmentScheduleDispatchStatuses } from './equipment-schedule-dispatch-statuses';
import { EquipmentScheduleTypes } from './equipment-schedule-types';


export interface EquipmentScheduleJournalItemResponse { 
    id?: string;
    dueAt?: string;
    dispatchedAt?: string | null;
    equipmentId?: string;
    ipAddress?: string | null;
    macAddress?: string | null;
    modelName?: string | null;
    firmwareFamily?: EquipmentFirmwareFamily;
    scheduleId?: string | null;
    scheduleName?: string | null;
    scheduleType?: EquipmentScheduleTypes;
    modeId?: number | null;
    status?: EquipmentScheduleDispatchStatuses;
    reasonCode?: string | null;
    message?: string | null;
    detailsJson?: string | null;
    facilityName?: string | null;
    containerName?: string | null;
    containerNumber?: number | null;
}



